<template>
  <div
    ref="rootEl"
    @click.stop
  >
    <slot :quantity="quantity" />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import useProduct from '../../uses/useProduct';

const rootEl = ref(null);
const { quantity } = useProduct();

onMounted(() => {
  const el = rootEl.value.querySelector('#product-quantity');
  const elDefault = rootEl.value.querySelector('#product-quantity-default');
  if (el) {
    el.classList.remove('hidden');
    el.classList.add('block');
  }

  if (elDefault) {
    elDefault.classList.add('hidden');
  }
});
</script>
